export const SET_CLIENTS_LIST = "CLIENT/SET_CLIENTS_LIST";

